import { MutableRefObject, useCallback } from "react";

export type TFormBuilderEntityDomNodeRefMap = MutableRefObject<Map<string, HTMLDivElement>>;

export function useFormBuilderEntityDomNodeRefMapRegistration(key: string, formBuilderEntityDomNodeRefMap: TFormBuilderEntityDomNodeRefMap) {
  return useCallback(
    (el: HTMLDivElement) => {
      if (el != null) {
        formBuilderEntityDomNodeRefMap.current.set(key, el);
      } else {
        formBuilderEntityDomNodeRefMap.current.delete(key);
      }
    },
    [key],
  );
}